import { $t } from '@/i18n';
import {
  XyCosSelectorMeta,
  XyCosSelectorEnvMeta,
} from '../paramsFormComponents';
import uploader from '@utils/upload';
import { CATEGORY } from './const';
import excelAtoms from './excel';
import { isPlainObject } from 'lodash';
import { getFileDataAtom } from './getFileDataAtom';

// 上传至COS
export const uploadToCOSAtom = {
  id: 'xy:source:uploader.uploadToCOS',
  name: $t('k_3c39e538'),
  category: CATEGORY.EXPORT,
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'cosId',
        type: 'string',
        title: $t('k_56794467'),
        'uc:allowInterop': true,
        ui: { type: 'XyCosSelector' },
      },
      {
        id: 'envConfig',
        type: 'object',
        title: $t('k_782e51cb'),
        ui: { type: 'XyCosEnvSelector' },
      },
      {
        id: 'file',
        type: 'string',
        title: $t('k_48792209'),
      },
      {
        id: 'path',
        type: 'string',
        title: $t('k_bd7bc3be'),
      },
      {
        id: 'headers',
        type: 'object',
        title: $t('k_6ae4af4e'),
        description: $t('k_2f3fb26f'),
        default: '',
        'uc:allowInterop': true,
        ui: {
          type: 'exprInput',
          props: {
            multipleLine: true,
          },
        },
      },
    ],
  },
  returnValue: {
    type: 'string',
    description: $t('k_f3907866'),
  },
  paramsFormComponents: [
    XyCosSelectorMeta,
    XyCosSelectorEnvMeta,
  ],
  async execute(ctx, params) {
    const { cosId, envConfig, file, path = '', headers = '' } = params;
    let customHeaders = null;
    if (headers && typeof headers === 'string') customHeaders = ctx.tryEval(headers);
    else if (isPlainObject(headers)) customHeaders = headers;
    const { projectId, env } = window.w;
    const cos = envConfig[env] || cosId;
    if (!file || !cos) {
      throw new Error($t('k_a92d86c2'));
    }
    const data = await uploader.upload({
      file,
      filePath: `/${path.replace(/^\//, '')}`,
      cosId: cos,
      projectId,
      headers: isPlainObject(customHeaders) ? customHeaders : null,
    });
    return data;
  },
};

export default [
  uploadToCOSAtom,
  ...excelAtoms,
  getFileDataAtom,
];
